@if (errorMessage()) {
  <div class="errorMessage">
    <pre>{{ errorMessage() }}</pre>
  </div>
}
<div class="content">
  @if (isLoaded) {
    <div class="configuration">
      <app-clm-product-line-header [isOem]="isOem()" [line]="entityLine()" (quantityChanged)="quantityChanged()"
        (tagInformationUpdated)="updateTaggingDetails($event)" [tags]="taggingDetails()">
      </app-clm-product-line-header>
      <app-swt-com-unit-information (valueChanged)="validateUnit()" [selectionEntities]="selectionEntities()"
        [imagePrefix]="imagePrefix"
        [invalidEntities]="invalidEntities()" [engineKey]="getEngineKey()">
      </app-swt-com-unit-information>
      <app-swt-com-accessories [selectionEntities]="selectionEntities()" [engineKey]="getEngineKey()"
        [invalidEntities]="invalidEntities()" (valueChanged)="validateUnit()">
      </app-swt-com-accessories>
      <app-w2w-sw-com-performance-header-input [invalidEntities]="invalidEntities()" [engineKey]="getEngineKey()"
        [selectionEntities]="selectionEntities()" (valueChanged)="validateUnit()">
      </app-w2w-sw-com-performance-header-input>
      <app-w2w-sw-com-cooling-performance-input [invalidEntities]="invalidEntities()" [engineKey]="getEngineKey()"
        [selectionEntities]="selectionEntities()" (valueChanged)="validateUnit()">
      </app-w2w-sw-com-cooling-performance-input>
      <app-w2w-sw-com-heating-performance-input [invalidEntities]="invalidEntities()" [engineKey]="getEngineKey()"
        [selectionEntities]="selectionEntities()" (valueChanged)="validateUnit()">
      </app-w2w-sw-com-heating-performance-input>
      <app-w2w-sw-com-cooling-performance-output [results]="$safeNavigationMigration(performanceResponse()?.coolingData)"></app-w2w-sw-com-cooling-performance-output>
      <app-w2w-sw-com-heating-performance-output [results]="$safeNavigationMigration(performanceResponse()?.heatingData)"></app-w2w-sw-com-heating-performance-output>
    </div>
  }
  <div class="prices">
    <app-skus-and-prices [modelImagePath]="unitImagePath()" [messages]="messages" [skus]="skus()" [sfrEntries]="sfrEntries()"
      [entityLeadTime]="entityLeadTime"
      [configurationLeadTime]="configurationLeadTime()" (sfrFlagChanged)="sfrFlagChanged()">
    </app-skus-and-prices>
  </div>
</div>
